import { Col, Container, Row, Hidden } from "react-grid-system";

import { StageTitle } from "../../../atoms/stage-title";
import { MainWrapper } from "../../../atoms/containers/main-wrapper";
import { MobileBackLink } from "../../../molecules/mobile-back-link";
import { TextsFrameImage } from "../../../atoms/texts-frame-image";
import { TextsDetailsBonusForm } from "../../../organisms/forms/texts-details-bonus";
import { DataLoadedContainer } from "../../../control/data-loaded-container";

import { useData } from "./use-data";

export const TextsDetailsBonus: React.FC = () => {
  const { formProps, loaderProps } = useData();

  return (
    <DataLoadedContainer {...loaderProps}>
      {formProps && (
        <MainWrapper>
          <Container>
            <Row>
              <Col md={6}>
                <MobileBackLink onClick={formProps.onClickBack}>Back</MobileBackLink>

                <Row>
                  <Col>
                    <StageTitle totalStages={3} currentStage={3}>
                      Send a Bonus Message at 7AM on Christmas Morning
                    </StageTitle>
                  </Col>
                </Row>

                <TextsDetailsBonusForm {...formProps} />
              </Col>
              <Hidden xs>
                <Col md={6}>
                  <TextsFrameImage />
                </Col>
              </Hidden>
            </Row>
          </Container>
        </MainWrapper>
      )}
    </DataLoadedContainer>
  );
};
